/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicBenchmarkCatalogue extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicBenchmarkCatalogue");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicBenchmarkCatalogue.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicBenchmarkCatalogue>): BackgroundJobPayloadForPeriodicBenchmarkCatalogue {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicBenchmarkCatalogue(), model);
        BackgroundJobPayloadForPeriodicBenchmarkCatalogue.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicBenchmarkCatalogue>): BackgroundJobPayloadForPeriodicBenchmarkCatalogue {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicBenchmarkCatalogue.newInstance(<BackgroundJobPayloadForPeriodicBenchmarkCatalogue> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicBenchmarkCatalogue) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicBenchmarkCatalogue.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicBenchmarkCatalogue): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicBenchmarkCatalogue.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
